module.exports = __webpack_public_path__ + "static/media/alert.fb62034c.svg";